export const findTableObject = (objectTable, obj1, obj2, value1, value2) => {
    let objectFound = false;
    let objIndx = objectTable.findIndex(elem => elem[obj1] === value1 && elem[obj2] ===  value2);
    if (objIndx === -1){
        objIndx = objectTable.findIndex(elem => elem[obj1] === value1);
        if (objIndx !== -1){
            objectFound = true;
        }
    }else{
        objectFound = true;
    }
    const returnObj = {found: objectFound, objIndx: objIndx}
    return returnObj;
}
export default findTableObject;